import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';

/**
 * Asynchronously retrieves available academic institutions for student non-employees.
 *
 * @function
 * @returns {Promise<Object[]>} array of academic institution key, value pairs.
 */
export const getStudentInstitutions = async () => {
	return axiosInstance
		.get('/api/UserAccessReview/GetStudentColleges')
		.then(async response => {
			return then(response, payload =>
				payload.map(institution => {
					return {
						key: institution,
						value: institution,
					};
				})
			);
		})
		.catch(error => {
			throw error;
		});
};

/**
 * Asynchronously retrieves available sub-user types mapped to the non-employee user type of interest.
 *
 * @function
 * @param {number} parentID unique identifier of non-employee user type of interest.
 * @returns {Promise<Object[]>} array of sub-user type key, value pairs.
 */
export const getSubUserTypes = async parentID => {
	return axiosInstance
		.get('/api/UserAccessReview/GetNonEmployeeUserSubtypes/' + parentID)
		.then(async response => {
			return then(response, payload =>
				payload.map(subUserType => {
					return {
						key: subUserType.Key,
						value: subUserType.Value,
					};
				})
			);
		})
		.catch(error => {
			throw error;
		});
}

/**
 * Asynchronously retrieves available non-employee user types.
 *
 * @function
 * @returns {Promise<Object[]>} array of user type key, value pairs.
 */
export const getUserTypes = async () => {
	return axiosInstance
		.get('/api/UserAccessReview/GetNonEmployeeUserTypes')
		.then(async response => {
			return then(response, payload =>
				payload.map(userType => {
					return {
						key: userType.Key,
						value: userType.Value,
					};
				})
			);
		})
		.catch(error => {
			throw error;
		});
};
